import { render, staticRenderFns } from "./_storeGoodsItem.vue?vue&type=template&id=5d61ec7d&"
import script from "./_storeGoodsItem.vue?vue&type=script&lang=js&"
export * from "./_storeGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./_storeGoodsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports